import SEO from '@ep/tools/seo';
import { resolveKnownImageSource } from '@ep/components/create/image';
const year = new Date().getFullYear();
const appConfig = (window?.config && typeof window.config === 'object') ? window.config : {};
const dictBranding = (dic?.branding && typeof dic.branding === 'object') ? dic.branding : {};
const headerLogoSource = dictBranding.logoUrl || appConfig.logoUrl || 'logo.png';
const headerLogoUrl = resolveKnownImageSource(headerLogoSource, 'product');
const headerLogoAlt = dictBranding.logoAlt || appConfig.logoAlt || dictBranding.productName || 'Logo';
SEO(dictBranding.seo);
document.querySelector('main')?.empty?.();

const handleAfterTopRoute = async ({ routeKey }) => {
  if (routeKey === 'modules') {
    document.getElementById('header-signup-button')?.disable();
  }
};

await create([
  {
    element: 'div',
    parent: 'header',
    class: 'header-content',
    isGrid: true,
    content: [
      {element: 'a', href: '/', class:'brand-link', isGrid: true, content: [
        {element: 'image', origin: 'external', src: headerLogoUrl, alt: headerLogoAlt, hasFigure: false, class: 'header-logo'},
      ]},     
    ]
  },
  {
    element: 'login',
    parent:'main',
    full: false,
    branding: dic?.branding || {}
  },
  {
    element: 'div', parent:'footer', text: dictBranding.footer.replace('{year}', year),
  }
]);
